import React from "react";
import { View } from '../../../components/templates/View';
import { CDInfraestructuraElectrica, CMInfraestructuraElectrica } from '../organisms';
import { useViewport } from "../../../hooks";

const InfraestructuraElectrica = () => {

    const { width } = useViewport();

    return(
        width > 850 ?
            <>
                <View children={ <CDInfraestructuraElectrica /> }/>
            </>
        :
            <>
                <View children={ <CMInfraestructuraElectrica/> }/>
            </>
    );
}

export default InfraestructuraElectrica;

